/* api/platform-invite — Platform user invitation flow */
import { post, get } from './client.js';

export const invite    = (name, email, role)  => post('/platform/users/invite', { name, email, role });
export const validate  = (token)              => get(`/auth/platform-invite/${token}/validate`);
export const accept    = (token, name, password) => post('/auth/platform-invite/accept', { token, name, password });
